import { Component, Input } from "@angular/core";
import { BusinessBanking } from "src/app/meta/BusinessBanking.interface";

@Component({
    selector: "ow-order-summary-business-banking",
    templateUrl: "./order-summary-business-banking.component.html"
})
export class OrderSummaryBusinessBankingComponent {

    @Input() businessBanking!: BusinessBanking
}
